//#region src/utils/isEvenNumber.ts
function isEven(number) {
	return number % 2 == 0;
}
//#endregion
export { isEven };

//# sourceMappingURL=isEvenNumber.js.map